// Unsaved kernel edits, keyed by kernel id. The Library page unmounts when
// the user leaves it — a kernel link into Explore, the nav rail, another
// kernel's tab — so edits held only in its state were lost on the way back
// (OR-369). Memory only: a reload still drops them.
//
// Each entry keeps the persisted kernel it was edited against. A draft whose
// base no longer matches the persisted kernel is stale (saved elsewhere while
// the page was away) and is dropped, the same as a mounted editor resetting
// its draft when the persisted kernel changes underneath it.

import { tenantViewDefinitionDiffers } from "./tenantViewCloudStore.js";

const drafts = new Map();

export function restoreKernelDraft(kernel) {
    const entry = drafts.get(kernel.id);
    if (!entry) return null;
    if (tenantViewDefinitionDiffers(entry.base, kernel)) {
        drafts.delete(kernel.id);
        return null;
    }
    return entry.draft;
}

export function holdKernelDraft(kernel, draft) {
    drafts.set(kernel.id, { base: kernel, draft });
}

export function releaseKernelDraft(kernelId) {
    drafts.delete(kernelId);
}

export function resetKernelDraftIdentityState() {
    drafts.clear();
}
